export enum MajicEventEnum {
    selectedCommune = 'selectedCommune',
    selectedCommunesUpdated = 'selectedCommunesUpdated',
}
